"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScheduleConfirmation = void 0;
const adaptivecards_1 = require("adaptivecards");
const cards_1 = require("../../survey/cards");
const DeleteScheduleAction_1 = require("../actions/DeleteScheduleAction");
const commands_1 = require("../commands");
const components_1 = require("../components");
const CardHelper_1 = require("../utils/CardHelper");
function createScheduleConfirmation(scheduleInfo) {
    let message;
    switch (scheduleInfo.type) {
        case "rrule":
        default:
            const scheduleStartDescription = getScheduleStartDescription(scheduleInfo.next);
            const frequencyDisplayText = scheduleInfo.frequency ? scheduleInfo.frequency + "" : "";
            message = `"${scheduleInfo.name}" is scheduled to be sent ${frequencyDisplayText} starting ${scheduleStartDescription}`;
            break;
    }
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: message,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: scheduleInfo.name,
        wrap: true,
        weight: adaptivecards_1.TextWeight.Bolder,
        size: adaptivecards_1.TextSize.Large,
    }));
    if (scheduleInfo.templateType === "poll") {
        const { container } = (0, cards_1.createScheduleContainer)(scheduleInfo, {
            showHeader: false,
            questionIndex: 0,
        });
        container.separator = true;
        container.spacing = adaptivecards_1.Spacing.Large;
        container.style = adaptivecards_1.ContainerStyle.Emphasis;
        card.addItem(container);
    }
    else {
        card.addItem((0, components_1.scheduleDetailsBar)(scheduleInfo, { activeCardDateFormat: true }));
    }
    card.addAction((0, DeleteScheduleAction_1.deleteScheduleAction)(scheduleInfo.id));
    card.addAction((0, commands_1.DeleteCardAction)());
    return card;
}
exports.createScheduleConfirmation = createScheduleConfirmation;
const getScheduleStartDescription = (startDate) => {
    return CardHelper_1.CardHelper.dateTimeReplacementString(startDate);
};
//# sourceMappingURL=ScheduleConfirmation.js.map